<div (click)="navigateToUrl()" class="m-1 shadow-2 flex flex-column h-full justify-content-center align-items-center p-2 cursor-pointer">
  <div class="flex flex-column justify-content-center align-items-center p-2">
    <img class="w-5" [src]=imageUrl alt="">
  </div>
  <h3 class="w-9rem text-center">{{ buttonText }}</h3>
</div>
